import { useContext } from "react";
import { AppContext } from "../../../app/AppContext.tsx";

export const useClaService = () => {
  const { claService } = useContext(AppContext);
  if (!claService) throw new Error("CLA Service not initialized");
  return claService;
};
